if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Header layout updates are grouped into one animation frame.
      this.startLayoutUpdates();

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    startLayoutUpdates() {
      this.stopLayoutUpdates();
      this.announcement_section = document.querySelector('.announcement-bar-section');
      this.layoutValues = Object.create(null);
      this.layoutSizesDirty = true;
      this.layoutUpdatesActive = true;
      this.onLayoutScroll = () => {
        if (!this.layoutUpdatesActive || this.layoutFrame) {
          return;
        }
        this.layoutFrame = window.requestAnimationFrame(() => {
          this.layoutFrame = 0;
          this.updateLayout();
        });
      };
      this.onLayoutResize = () => {
        this.layoutSizesDirty = true;
        this.onLayoutScroll();
      };
      window.addEventListener('scroll', this.onLayoutScroll, {
        passive: true
      });
      window.addEventListener('resize', this.onLayoutResize);
      if (typeof ResizeObserver !== 'undefined') {
        this.layoutObserver = new ResizeObserver(this.onLayoutResize);
        this.layoutObserver.observe(this);
        if (this.announcement_section) {
          this.layoutObserver.observe(this.announcement_section);
        }
      }
      this.updateLayout();
    }
    updateLayout() {
      if (!this.layoutUpdatesActive) {
        return;
      }
      // Read geometry together before changing classes or CSS custom properties.
      const stickyEnabled = this.classList.contains('header-sticky--active'),
        wasSticky = this.classList.contains('is-sticky'),
        scrollY = window.scrollY,
        stickyOffset = stickyEnabled ? parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop : 0,
        headerOffset = this.header_section.getBoundingClientRect().top,
        headerHeight = this.layoutSizesDirty ? this.clientHeight : null,
        announcementHeight = this.layoutSizesDirty && this.announcement_section ? this.announcement_section.clientHeight : null,
        isSticky = scrollY >= stickyOffset && scrollY > 0;
      this.layoutSizesDirty = false;
      if (stickyEnabled && isSticky !== wasSticky) {
        this.classList.toggle('is-sticky', isSticky);
        // A sticky class can affect geometry; measure its settled state next frame.
        this.onLayoutResize();
      }
      this.writeLayoutValue('--header-offset', headerOffset);
      if (headerHeight !== null) {
        this.writeLayoutValue('--header-height', headerHeight);
      }
      if (announcementHeight !== null) {
        this.writeLayoutValue('--announcement-height', announcementHeight);
      }
    }
    writeLayoutValue(name, value) {
      const pixels = value + 'px';
      if (this.layoutValues[name] === pixels) {
        return;
      }
      this.layoutValues[name] = pixels;
      document.documentElement.style.setProperty(name, pixels);
    }
    stopLayoutUpdates() {
      this.layoutUpdatesActive = false;
      if (this.onLayoutScroll) {
        window.removeEventListener('scroll', this.onLayoutScroll);
      }
      if (this.onLayoutResize) {
        window.removeEventListener('resize', this.onLayoutResize);
      }
      if (this.layoutFrame) {
        window.cancelAnimationFrame(this.layoutFrame);
      }
      this.layoutFrame = 0;
      if (this.layoutObserver) {
        this.layoutObserver.disconnect();
      }
      this.layoutObserver = null;
    }
    disconnectedCallback() {
      this.stopLayoutUpdates();
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
